package com.hyperether.goodjob.repository.remote.model

import com.hyperether.goodjob.models.User
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SubscribeToPlanResponse(
    @SerialName("user") var user: User? = null,
    @SerialName("message") var message: String? = null
)